export const CreatedDateText = ({createdDate} : {createdDate: string}) => {
  return (
    <>
    Statement as at: <strong>{createdDate}</strong>
    </>
  );
};